import { CustomDocumentFloatingToolbarConfig } from '../types';
import { DocumentEditorFloatingToolbarConfig } from '../types';

export const isCustomToolbarConfig = (
  config: DocumentEditorFloatingToolbarConfig,
): config is CustomDocumentFloatingToolbarConfig => {
  return 'toolbar' in config;
};
